import {LandType} from '.cache/__types__';
import {FormattedMessage} from 'react-intl';

export const translations = {
    [LandType.Les]: <FormattedMessage defaultMessage="Les" />,
    [LandType.Bydleni]: <FormattedMessage defaultMessage="Bydlení" />,
    [LandType.Komercni]: <FormattedMessage defaultMessage="Komerční" />,
    [LandType.Rybnik]: <FormattedMessage defaultMessage="Rybník" />,
    [LandType.Zahrada]: <FormattedMessage defaultMessage="Zahrada" />,
    [LandType.Pole]: <FormattedMessage defaultMessage="Pole" />,
    [LandType.Louka]: <FormattedMessage defaultMessage="Louka" />,
    [LandType.Ostatni]: <FormattedMessage defaultMessage="Ostatní" />,
    [LandType.Undefined]: <FormattedMessage defaultMessage="Nespecifikováno" />,
};
